module.exports = __webpack_public_path__ + "img/home.09a5ec53.svg";